import { render, staticRenderFns } from "./pmsPackagePricingComponent.vue?vue&type=template&id=78d854e4&"
import script from "./pmsPackagePricingComponent.vue?vue&type=script&lang=js&"
export * from "./pmsPackagePricingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports